import { Button } from "@amzn/storm-ui";
import { isEmpty } from "lodash";
import * as React from "react";
import { useStore } from "zustand";

import { useCreateInsightLinkageAndDownload } from "../../hooks/insightLinkage/useCreateInsightLinkageAndDownload";
import { useAsyncErrorStatusNotification } from "../../hooks/notifications/useAsyncErrorStatusNotification";
import { csatFeedbackStore } from "../../store/csatFeedback";
import { InsightLinkageStore } from "../../store/insightLinkage";
import { reportIssueStore } from "../../store/reportIssue";
import { AquilaReportIssueTriggerType } from "../../types/aquila";
import { isLoading } from "../../utils/api.utils";
import { SalesforceErrorNotification } from "../common/ErrorNotificationWithLink";
import {
    DivFlexJustifyRight,
    ModalFooterCancelButton,
    ModalFooterContainer,
} from "../common/styled.components";

export const InsightLinkageFooter: React.FunctionComponent = () => {
    const [sfObject, insightLinkageMetadata, resetInsightLinkage] = useStore(
        InsightLinkageStore,
        (state) => [
            state.sfObject,
            state.insightLinkageMetadata,
            state.resetInsightLinkage,
        ],
    );

    const [updateReportIssueContextData, openModal] = useStore(
        reportIssueStore,
        (state) => [state.updateReportIssueContextData, state.openModal],
    );

    const {
        title,
        content,
        insightType,
        identifier,
        downloadUrl,
        description,
        contentId,
        contentVersion,
    } = insightLinkageMetadata;

    const [insightLinkageState, insightLinkageAction] =
        useCreateInsightLinkageAndDownload();

    useAsyncErrorStatusNotification(
        insightLinkageState,
        [],
        {
            Error: (
                <SalesforceErrorNotification
                    onReportClick={() =>
                        openModal(AquilaReportIssueTriggerType.SIDE_PANEL)
                    }
                />
            ),
        },
        identifier,
        (error) => {
            updateReportIssueContextData({
                apiError: {
                    requestUrl: "createInsightLinkage API",
                    requestPayload: JSON.stringify({
                        sfObjectId: sfObject.sfObjectId,
                        sfObjectType: sfObject.sfObjectType,
                        contentId,
                    }),
                    errorResponse: error.message || JSON.stringify(error),
                    errorCode: error.statusCode || error.code || "Unknown",
                },
            });
        },
    );

    const [setIsEligibleToProvideFeedback] = useStore(
        csatFeedbackStore,
        (state) => [state.setHasUserPerformedActionWorthFeedback],
    );

    const handleDownload = async () => {
        await insightLinkageAction.execute({
            title,
            content,
            insightType,
            identifier,
            downloadUrl,
            description,
            contentId,
            contentVersion,
        });
        setIsEligibleToProvideFeedback(true);
    };

    return (
        <ModalFooterContainer>
            <ModalFooterCancelButton
                onClick={() => resetInsightLinkage()}
                data-testid="insight-linkage-reset"
            >
                Cancel
            </ModalFooterCancelButton>
            <br />
            <DivFlexJustifyRight>
                <Button
                    loading={isLoading(insightLinkageState.status)}
                    data-testid="create-insight-linkage"
                    type="submit"
                    variant="primary"
                    onClick={() => void handleDownload()}
                    disabled={isEmpty(sfObject.sfObjectId)}
                >
                    Apply & download insight
                </Button>
            </DivFlexJustifyRight>
        </ModalFooterContainer>
    );
};
